import ReactDOM from 'react-dom';
import React, { Fragment } from 'react';
 import ReactPDF, { Page, Text, View, Document, StyleSheet, Image, Font } from '@react-pdf/renderer';
import { IReceivedPayments } from '../models/payments';


interface PagosPDFProps {
    pagosData: IReceivedPayments[]
    propietario: string
    casa: string
    condominio: string
}

export const PagosPDF = (props: PagosPDFProps) => {
    
     const { pagosData: estadoData, propietario, casa, condominio } = props

    Font.register({
        family: 'Open Sans',
        fonts: [
            { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
            { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-400.ttf', fontWeight: 400 },
            { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600 }
        ]
    })

    const styles = StyleSheet.create({

        page: { fontSize: 11, paddingTop: 20, paddingLeft: 40, paddingRight: 40, lineHeight: 1.5, flexDirection: 'column', fontFamily: 'Open Sans' },

        spaceBetween: { flex : 1, flexDirection: 'row', alignItems:'center', justifyContent:'space-between', color: "#3E3E3E" },

        titleContainer: { flexDirection: 'row', marginTop: 24 },

        anchorToBottom: { position: 'absolute', bottom: 30, left: 40, right: 40 },
        
        imageContainer: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%' },

        logo: { width: 100, height: 100 },

        footerImage: { width: 150 },
        
        alignRight: { textAlign: 'right' },
        
        title: { fontSize: 16,  textAlign: 'center', width: '100%' },
        
        details: { fontSize: 11, fontWeight: 'bold' }, 
        
        cell: { fontSize: 10, paddingTop: 4, paddingLeft: 7, paddingRight: 7, borderColor : 'grey', borderBottomWidth:1, borderRightWidth:1 },
        
        boldCell: { fontWeight: 'extrabold' },

        theader: { marginTop : 20, backgroundColor : '#FFCC00',  borderRightWidth:1, borderTopWidth:1 },

        theader1: { flex:1, borderLeftWidth:1 },

        theader2: { flex:2 },

        theader3: { flex:1 },

        tbody1: { flex:1, borderLeftWidth:1 },

        tbody2: { flex:2 },

        tbody3: { flex:1 },



    })

    const Header = () => (
        <View style={styles.titleContainer}>
            <View style={styles.spaceBetween}>
                {/*<Image style={styles.logo} src={logo} />*/}
                <Text style={styles.title}>{condominio ? condominio : 'Diceros'}</Text>
            </View>
        </View>
    )

    const Details = () => (
        <View style={styles.titleContainer}>
            <View style={styles.spaceBetween}>
                <View>
                    <Text style={styles.title}>Pagos Recibidos </Text>
                    <Text style={styles.details}>Propietario: {propietario} </Text>
                    <Text style={styles.details}>Casa {casa}</Text>
                </View>
            </View>
        </View>
    )

    const TableHead = () => (
        <>
        <View style={{ width:'100%', flexDirection :'row', marginTop:10}}>
            <View style={[styles.theader, styles.theader1, styles.cell, styles.boldCell]}>
                <Text>Fecha</Text>   
            </View>
            <View style={[styles.theader, styles.theader2, styles.cell, styles.boldCell]}>
                <Text>No. Recibo</Text>
            </View>
            <View style={[styles.theader, styles.theader3, styles.cell, styles.boldCell]}>
                <Text>Monto</Text>   
            </View>
        </View>
        </>
    )

    const TableBody = () => (
        <>
        {estadoData.map((item)=>(
        <Fragment key={item.id}>
            <View style={{ width:'100%', flexDirection :'row'}}>
                <View style={[styles.tbody1, styles.cell]}>
                    <Text>{item.fecha}</Text>   
                </View>
                <View style={[styles.tbody2, styles.cell]}>
                    <Text>{item.num_Boleta}</Text>   
                </View>
                <View style={[styles.tbody3, styles.cell, styles.alignRight]}>
                    <Text>{item.valor}</Text>   
                </View>
            </View>
        </Fragment>
        ))}
        </>
    )


    const Footer = () => (
        <View style={[styles.titleContainer, styles.anchorToBottom]}>
            <View style={[styles.spaceBetween, styles.imageContainer]}>
                <Image style={styles.footerImage} src='/assets/DicerosLogo2.png' />
            </View>
        </View>
    )
  
    return (
        
        <Document>
            <Page size="A4" style={styles.page}>
                <Header  />
                <Details/>
                <TableHead/>
                <TableBody/>
                <Footer/>
            </Page>
        </Document>
    )

}
